import {Mixin} from "mixwith/mixwith";

let ClassOptionMixin = null;
export let OptionMixin = Mixin((superclass) => {
        ClassOptionMixin = class extends superclass {
            constructor() {
                super(...arguments);
                this._options = [];
            }

            addOptions(options) {
                this._options = [...this._options, ...options];
                return this;
            }
        }
        return ClassOptionMixin
    }
);

export {ClassOptionMixin};
